import { filterMaybe } from '@edge/spark/utils'
import { useUserRolesQuery } from '../generated/graphql'
import { ReportRoles } from '../enums'
import { checkRoles } from '../utils/checkRoles'
import { useIsGlobalAdmin } from './useIsGlobalAdmin'
import { useRoles } from './useRoles'

export const useRoleNames = (): string[] => {
    const roles = useRoles()
    return roles.map((r) => r.name).filter(filterMaybe)
}

export const useRoleCheck = (requiredRoleNames: string[]): boolean => {
    const roles = useRoles()
    return requiredRoleNames.some((reqRole) => roles.map((r) => r.name).includes(reqRole))
}

export const useCheckRolesOrAdmin = (requiredRoleNames: string[], isAdmin = true): boolean => {
    const isEdgeAdmin = useIsGlobalAdmin()
    const allowedByRole = useRoleCheck(requiredRoleNames)
    if (isAdmin) {
        return isEdgeAdmin || allowedByRole
    }
    return allowedByRole
}

export const useCheckReportRoles = (): boolean => {
    const { data } = useUserRolesQuery()
    const roles = data?.user?.roles?.filter(filterMaybe) || []
    const possibleRoles = [ReportRoles.BASIC, ReportRoles.FINANCIALS]
    return checkRoles(roles, possibleRoles, true)
}

export const useCheckReportRolesOrAdmin = (): boolean =>
    useCheckRolesOrAdmin([ReportRoles.BASIC, ReportRoles.FINANCIALS])
